import {Injectable} from "@angular/core";
import {createEvent} from "../misc/event.polyfill";
import {MicroFormModel} from "./micro-form.model";
import {HttpClient} from "@angular/common/http";
import {Apollo} from "apollo-angular";
import {GqlMicroFormQueryModel} from "../graphql/graphql.model";
import {map} from "rxjs/operators";

@Injectable()
export class MicroFormService {
  constructor(private http: HttpClient, private apollo: Apollo) {}

  save(model: MicroFormModel): Promise<any> {
    const value = model.editorValue;

    if (model.mutation && model.saveUrl) {
      throw new Error("Expected MicroFormModel to have mutation or saveUrl, but NOT both!");
    }

    if (model.mutation) {
      const gqlModel = model.mutation.build(value);

      return this.apollo.mutate({mutation: gqlModel.mutation, variables: gqlModel.variables, fetchPolicy: "no-cache"})
        .pipe(
          gqlModel.mapper,
          map((result: GqlMicroFormQueryModel) => result.paramValue),
        )
        .toPromise()
        .then(
          (result) => {
            model.writeValue(value);
            model.stopEditing();
            this.emitSaved(model, value, result);
            this.emitError(model);
            return result;
          },
        );
    }

    return this.http.post(model.saveUrl, {paramName: model.paramName, value})
      .toPromise()
      .then(
        (result) => {
          model.writeValue(value);
          model.stopEditing();
          this.emitSaved(model, value, result);
          this.emitError(model);
          return result;
        },
        (error) => {
          this.emitError(model, error);
          throw error;
        },
      );
  }

  cancel(model: MicroFormModel): void {
    model.editorValue = model.displayValue;
    model.stopEditing();
    this.emitCancel(model);
    this.emitError(model);
  }

  emitSaved(model: MicroFormModel, value?: any, result?: any) {
    const event = createEvent("saved");
    event["value"] = value;
    event["result"] = result;
    model.savedEmitter.emit(event);
  }

  emitError(model: MicroFormModel, error?: Error) {
    const event = createEvent("error");
    event["error"] = error;
    model.errorEmitter.emit(event);
  }

  emitCancel(model: MicroFormModel) {
    const event = createEvent("cancel");
    model.cancelledEmitter.emit(event);
  }
}
